import React from 'react';
import { Check } from 'lucide-react';

const steps = [
  { id: 1, name: 'Validación Email', icon: '📧' },
  { id: 2, name: 'Reglas', icon: '📜' },
  { id: 3, name: 'Beneficios', icon: '🎁' },
  { id: 4, name: 'Video Bienvenida', icon: '🎥' },
  { id: 5, name: 'Finalizar Onboarding', icon: '✅' },
  { id: 6, name: 'Únete al Discord', icon: '💬' },
  { id: 7, name: 'Reclama tu Role', icon: '🎖️' }
];

const StepTracker = ({ currentStep }) => {
  const activeStep = steps.find((s) => s.id === currentStep);

  return (
    <div className="mb-8">
      {/* Etiqueta compacta solo visible en mobile */}
      {activeStep && (
        <p className="sm:hidden text-center text-yellow-500 text-sm font-semibold mb-3">
          Paso {activeStep.id} de {steps.length}: {activeStep.name}
        </p>
      )}

      <div className="flex items-start justify-between max-w-4xl mx-auto">
        {steps.map((step, index) => {
          const isCompleted = currentStep > step.id;
          const isCurrent = currentStep === step.id;

          return (
            <React.Fragment key={step.id}>
              <div className="flex flex-col items-center relative shrink-0">
                <div
                  className={`flex items-center justify-center rounded-full transition-all duration-300 w-7 h-7 text-xs sm:w-12 sm:h-12 sm:text-xl ${
                    isCompleted
                      ? 'bg-gradient-to-r from-yellow-500 to-yellow-600'
                      : isCurrent
                      ? 'bg-yellow-500/20 border-2 border-yellow-500 ring-2 ring-yellow-500/40 animate-pulse'
                      : 'bg-gray-800 border-2 border-gray-700'
                  }`}
                >
                  {isCompleted ? (
                    <Check className="w-4 h-4 sm:w-6 sm:h-6 text-black" />
                  ) : (
                    <span>{step.icon}</span>
                  )}
                </div>
                {/* Texto solo en pantallas medianas en adelante */}
                <p
                  className={`hidden sm:block text-xs mt-2 text-center max-w-[80px] transition-colors ${
                    isCurrent ? 'text-yellow-500 font-semibold' : isCompleted ? 'text-gray-400' : 'text-gray-600'
                  }`}
                >
                  {step.name}
                </p>
              </div>

              {index < steps.length - 1 && (
                <div
                  className={`flex-1 h-1 mx-1 sm:mx-2 rounded transition-all duration-500 mt-3 sm:mt-6 ${
                    isCompleted ? 'bg-gradient-to-r from-yellow-500 to-yellow-600' : 'bg-gray-800'
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepTracker;
